import React, { useId } from 'react';
import { dateTo12hParts, parts12hToDate } from './businessHoursTime';

const HOURS = [12, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11];
const MINUTES = Array.from({ length: 60 }, (_, i) => i);

/**
 * Hour + minute + AM/PM selects — easier on mobile than native time input.
 */
export default function BhTimeSelect({ id, label, value, onDateChange, disabled = false }) {
  const labelId = useId();
  const refDate = value instanceof Date && !isNaN(value.getTime()) ? value : new Date();
  const { hour12, minute, period } = dateTo12hParts(
    value instanceof Date && !isNaN(value.getTime()) ? value : null
  );

  const apply = (nextH, nextM, nextP) => {
    const d = parts12hToDate(nextH, nextM, nextP, refDate);
    onDateChange(d);
  };

  return (
    <div className="bh-field bh-field--time-select">
      <div id={labelId} className="bh-field__label">
        {label}
      </div>
      <div
        className="bh-time-select__track"
        role="group"
        aria-labelledby={labelId}
      >
        <select
          id={`${id}-hour`}
          className="bh-time-select__segment bh-time-select__segment--hour"
          aria-label={`${label}, hour`}
          value={hour12}
          disabled={disabled}
          onChange={(e) => apply(parseInt(e.target.value, 10), minute, period)}
        >
          {HOURS.map((h) => (
            <option key={h} value={h}>
              {h}
            </option>
          ))}
        </select>
        <span className="bh-time-select__colon" aria-hidden>
          :
        </span>
        <select
          id={`${id}-minute`}
          className="bh-time-select__segment bh-time-select__segment--minute"
          aria-label={`${label}, minutes`}
          value={minute}
          disabled={disabled}
          onChange={(e) => apply(hour12, parseInt(e.target.value, 10), period)}
        >
          {MINUTES.map((m) => (
            <option key={m} value={m}>
              {m.toString().padStart(2, '0')}
            </option>
          ))}
        </select>
        <span className="bh-time-select__rail" aria-hidden />
        <select
          id={`${id}-ampm`}
          className="bh-time-select__segment bh-time-select__segment--ampm"
          aria-label={`${label}, AM or PM`}
          value={period}
          disabled={disabled}
          onChange={(e) => apply(hour12, minute, e.target.value)}
        >
          <option value="AM">AM</option>
          <option value="PM">PM</option>
        </select>
      </div>
    </div>
  );
}
